import {EntityService} from '../../../service/EntityService';

export class AccountService extends EntityService {

  static entity = 'vinca-auth/privileges/admin/user-accounts';

  static resetPassword(userId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${userId}/reset-password`, data).then(res => res.data);
  }
}